export default __webpack_public_path__ + "static/media/btcW.5833f977.svg";